import LBox from "@components/LBox";
import type { YouBreakdownModalProps } from "@components/modals/YouBreakdownModal/types";
import { YouBreakdownContent } from "@components/modals/YouBreakdownModal/YouBreakdownContent";
import { BottomSheetHandle } from "@utils/swmModal/components/BottomSheetPrimitives";
import AppModalSheet from "@utils/appModal/components/AppModalSheet";
import { APP_MODAL_CORNER_RADIUS } from "@utils/appModal/constants";
import { forwardRef } from "react";
import { StyleSheet, View } from "react-native";
import type { SheetAdapterRef } from "react-native-bottom-sheet-stack";

const DarkSheetSurface = () => (
  <View style={[StyleSheet.absoluteFill, styles.darkSurface]} />
);

const YouBreakdownModalSWM = (props: YouBreakdownModalProps) => (
  <LBox pb="l1">
    <BottomSheetHandle backgroundColor="whiteTranslucent70" />
    <LBox p="s4" pt="s2">
      <YouBreakdownContent {...props} levelProgressHeight={170} />
    </LBox>
  </LBox>
);

export const YouBreakdownModalSWMSheet = forwardRef<
  SheetAdapterRef,
  YouBreakdownModalProps
>(function YouBreakdownModalSWMSheet(props, ref) {
  return (
    <AppModalSheet ref={ref} showHandle={false} surface={<DarkSheetSurface />}>
      <YouBreakdownModalSWM {...props} />
    </AppModalSheet>
  );
});

export default YouBreakdownModalSWM;

const styles = StyleSheet.create({
  darkSurface: {
    backgroundColor: "#17171C",
    borderTopLeftRadius: APP_MODAL_CORNER_RADIUS,
    borderTopRightRadius: APP_MODAL_CORNER_RADIUS,
    overflow: "hidden",
  },
});
